// Client-side-only hints for fast feedback before the file ever reaches the
// server. The backend is the source of truth and re-validates everything
// (extension, magic bytes, size, page count) - see
// backend/app/services/upload_service.py.
export const MAX_UPLOAD_SIZE_BYTES = 52_428_800; // 50 MiB, keep in sync with .env MAX_UPLOAD_SIZE_BYTES
export const ACCEPTED_EXTENSION = ".pdf";
export const JOB_POLL_INTERVAL_MS = 2000;
